/**
 * Integração direta Correios (CWS) POR EMPRESA emitente — [Shipping].[CorreiosIntegration],
 * uma linha por company_id (contrato, cartão de postagem, credenciais e token próprios).
 * Cadastro em Configuração → Transporte → Transportadoras → Correios → "Integração por empresa".
 * As credenciais chegam em texto claro por decisão (tela restrita a shipping_integrations.*).
 */

export type CorreiosAmbiente = 'producao' | 'homologacao';

export const CORREIOS_BASE_URL: Record<CorreiosAmbiente, string> = {
  producao: 'https://api.correios.com.br',
  homologacao: 'https://apihom.correios.com.br',
};

export interface CorreiosIntegration {
  correios_integration_id: number;
  company_id: number;
  company_name: string;
  company_document: string;
  enabled: boolean;
  ambiente: CorreiosAmbiente;
  base_url: string;
  rastro_base_url?: string | null;
  usuario: string;
  /** Código de acesso à API gerado no portal CWS (não é a senha do site) — texto claro. */
  codigo_acesso_api: string;
  contrato: string;
  cartao_postagem: string;
  dr?: number | null;
  timeout_seconds: number;
  /** Teto de valor declarado por objeto, em centavos. Ausente = sem teto. */
  declared_value_cap_cents?: number | null;
  /** Só diagnóstico: validade do token vigente / claim de renovação em andamento. */
  token_expira_em?: string | null;
  renewal_in_progress_at?: string | null;
  updated_at: string;
  updated_by?: string | null;
}

/** Corpo do PUT /shipping/correios-integrations/:companyId (upsert). */
export interface CorreiosIntegrationFormData {
  enabled: boolean;
  ambiente: CorreiosAmbiente;
  base_url: string;
  rastro_base_url: string | null;
  usuario: string;
  codigo_acesso_api: string;
  contrato: string;
  cartao_postagem: string;
  dr: number | null;
  timeout_seconds: number | null;
  declared_value_cap_cents: number | null;
}

export interface CorreiosCredentialsTestResult {
  ok: boolean;
  status_code: number;
  message: string;
  expira_em?: string | null;
}
